import React from 'react';
import Icon, { IconProps } from '../Icon';

const TrashIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 13 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 2.78125V3.59375C13 3.81812 12.8181 4 12.5938 4H0.40625C0.181884 4 0 3.81812 0 3.59375V2.78125C0 2.55688 0.181884 2.375 0.40625 2.375H4.0625V1.5625C4.0625 1.11377 4.42627 0.75 4.875 0.75H8.125C8.57373 0.75 8.9375 1.11377 8.9375 1.5625V2.375H12.5938C12.8181 2.375 13 2.55688 13 2.78125ZM1.51937 15.4887C1.57921 16.3415 2.28952 17.0021 3.14438 17H9.87187C10.7267 17.0021 11.437 16.3415 11.4969 15.4887L12.1875 5.625H0.8125L1.51937 15.4887Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default TrashIcon;
